.container {
	text-align: center;
	color: $errorColor2;
	font-weight: 600;
	font-size: 0.75rem;
}
